import { MRT_Row } from 'material-react-table'

import { StructureExportDto } from '@/endpoints/models'
import { SourceEnums } from '@/endpoints/schemas'
import { GetAvailableStructureForSourceObjectUsingGetApiResponse } from '@/rtkApi/mddApiSliceGenerated'
import { SourceItem } from '@/rtkApi/mddApiSliceGeneratedV2'

interface GetAvailableStructuresProps {
	sourceItemRow: MRT_Row<SourceItem> | SourceItem | undefined
	systemTables:
		| GetAvailableStructureForSourceObjectUsingGetApiResponse
		| undefined
}

const isMRTRow = (
	row: MRT_Row<SourceItem> | SourceItem,
): row is MRT_Row<SourceItem> => {
	return row && 'original' in row
}

export const getAvailableStructures = ({
	sourceItemRow,
	systemTables,
}: GetAvailableStructuresProps) => {
	if (!systemTables || !sourceItemRow) {
		return []
	}

	const objectType = isMRTRow(sourceItemRow)
		? sourceItemRow.original?.objectType
		: sourceItemRow?.objectType

	switch (objectType) {
		case SourceEnums.ObjectTypeEnum.TABLE:
			return systemTables.filter(
				(c) => c?.type === StructureExportDto.TypeEnum.TABLE,
			)
		case SourceEnums.ObjectTypeEnum.VIEW:
			return systemTables.filter(
				(c) => c?.type === StructureExportDto.TypeEnum.VIEW,
			)
		case SourceEnums.ObjectTypeEnum.DUMMY:
			return systemTables.filter(
				(c) =>
					c?.type === StructureExportDto.TypeEnum.TABLE ||
					c?.type === StructureExportDto.TypeEnum.VIEW,
			)
		default:
			return []
	}
}
